<template>
    <div>
        <!-- FASE 4 / BLOCO AB — DOC 19, 48, 49, 50, 55, 56, 57, 58, 60, 61 -->

        <el-tabs v-model="aba">
            <!-- DOC 48, 49, 50 -->
            <el-tab-pane label="Dados adicionais" name="campos">
                <el-row class="u-mt-10 u-mb-10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="primary" icon="el-icon-plus" size="small"
                                   @click="abrirCampo(null)">NOVO CAMPO</el-button>
                    </el-col>
                </el-row>

                <div class="container-table" v-loading="!statusCampos">
                    <table class="table table-striped">
                        <thead>
                            <tr><th>Nome</th><th style="width:110px">Tipo</th>
                                <th style="width:110px" class="u-text-center">Obrigatório</th>
                                <th style="width:90px" class="u-text-center">Ativo</th>
                                <th style="width:110px" class="u-text-center">Ação</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="c in campos" :key="c.id">
                                <td>{{ c.nome }}<el-tag v-if="c.instituicao_id === null" size="mini" type="warning" class="u-ml-5">rede</el-tag></td>
                                <td>{{ c.tipo }}</td>
                                <td class="u-text-center">{{ c.obrigatorio ? 'Sim' : 'Não' }}</td>
                                <td class="u-text-center">{{ c.ativo ? 'Sim' : 'Não' }}</td>
                                <td class="u-text-center acao">
                                    <el-button type="info" icon="el-icon-edit" size="mini" plain
                                               @click="abrirCampo(c)"></el-button>
                                    <el-button class="u-ml-10" type="danger" icon="el-icon-delete" size="mini" plain
                                               @click="excluirCampo(c)"></el-button>
                                </td>
                            </tr>
                            <tr v-if="!campos.length && statusCampos">
                                <td colspan="5" class="u-text-center">Nenhum campo cadastrado.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- DOC 55, 56, 57, 58 -->
            <el-tab-pane label="Regras de armazenamento" name="regras">
                <el-alert type="info" :closable="false" show-icon class="u-mt-10 u-mb-10"
                          title="A regra guarda o documento na pasta certa e pode renomeá-lo."
                          :description="'Variáveis disponíveis: ' + variaveisTexto"></el-alert>

                <el-row class="u-mb-10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="primary" icon="el-icon-plus" size="small"
                                   @click="abrirRegra(null)">NOVA REGRA</el-button>
                    </el-col>
                </el-row>

                <div class="container-table" v-loading="!statusRegras">
                    <table class="table table-striped">
                        <thead>
                            <tr><th>Nome</th><th>Quando</th><th>Guardar em</th><th>Renomear para</th>
                                <th style="width:110px" class="u-text-center">Ação</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="r in regras" :key="r.id">
                                <td>{{ r.nome }}</td>
                                <td class="meta">{{ descricaoGatilho(r) }}</td>
                                <td class="meta">{{ r.caminho_modelo || nomePasta(r.pasta_destino_id) || '—' }}</td>
                                <td class="meta">{{ r.nome_modelo || '—' }}</td>
                                <td class="u-text-center acao">
                                    <el-button type="info" icon="el-icon-edit" size="mini" plain
                                               @click="abrirRegra(r)"></el-button>
                                    <el-button class="u-ml-10" type="danger" icon="el-icon-delete" size="mini" plain
                                               @click="excluirRegra(r)"></el-button>
                                </td>
                            </tr>
                            <tr v-if="!regras.length && statusRegras">
                                <td colspan="5" class="u-text-center">Nenhuma regra cadastrada.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- DOC 60, 61 -->
            <el-tab-pane label="Transferência de acervo" name="transferencia">
                <el-row :gutter="10" class="u-mt-10 u-mb-10">
                    <el-col :xs="24" :sm="8">
                        <el-select v-model="transf.de_user_id" filterable remote :remote-method="buscarUsuarios"
                                   :loading="buscando" placeholder="De (usuário de origem)" style="width:100%"
                                   @change="carregarPrevia">
                            <el-option v-for="u in usuarios" :key="u.id" :label="u.name" :value="u.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-select v-model="transf.para_user_id" filterable remote :remote-method="buscarUsuarios"
                                   :loading="buscando" placeholder="Para (usuário de destino)" style="width:100%">
                            <el-option v-for="u in usuarios" :key="u.id" :label="u.name" :value="u.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-button type="warning" icon="el-icon-sort" @click="executarTransferencia"
                                   :disabled="!transf.de_user_id || !transf.para_user_id">
                            TRANSFERIR
                        </el-button>
                    </el-col>
                </el-row>

                <el-alert v-if="previa" type="warning" :closable="false" show-icon class="u-mb-15"
                          :title="`Serão transferidos ${previa.documentos} documento(s) e ${previa.pastas} pasta(s).`"
                          description="A operação não pode ser desfeita automaticamente.">
                </el-alert>

                <el-divider content-position="left">Transferências realizadas (DOC 61)</el-divider>

                <div class="container-table" v-loading="!statusTransf">
                    <table class="table table-striped">
                        <thead>
                            <tr><th>De</th><th>Para</th><th class="u-text-center" style="width:90px">Docs</th>
                                <th class="u-text-center" style="width:90px">Pastas</th>
                                <th>Executado por</th><th style="width:140px">Quando</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="t in transferencias" :key="t.id">
                                <td>{{ t.origem }}</td>
                                <td>{{ t.destino }}</td>
                                <td class="u-text-center">{{ t.quantidade_documentos }}</td>
                                <td class="u-text-center">{{ t.quantidade_pastas }}</td>
                                <td>{{ t.executor }}</td>
                                <td>{{ t.created_at | formatarData }}</td>
                            </tr>
                            <tr v-if="!transferencias.length && statusTransf">
                                <td colspan="6" class="u-text-center">Nenhuma transferência realizada.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- DOC 19 -->
            <el-tab-pane label="Auditoria" name="auditoria">
                <el-row :gutter="10" class="u-mt-10 u-mb-10">
                    <el-col :xs="12" :sm="5">
                        <el-select v-model="filtroAud.acao" placeholder="Ação" clearable
                                   style="width:100%" @change="carregarAuditoria">
                            <el-option v-for="a in acoes" :key="a" :label="a" :value="a"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-select v-model="filtroAud.alvo_tipo" placeholder="Tipo" clearable
                                   style="width:100%" @change="carregarAuditoria">
                            <el-option label="Documento" value="documento"></el-option>
                            <el-option label="Pasta"     value="pasta"></el-option>
                            <!-- DOC 18/19 — mudar autorização é movimentação auditável -->
                            <el-option label="Autorização" value="autorizacao"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-date-picker v-model="filtroAud.de" type="date" placeholder="De"
                                        value-format="yyyy-MM-dd" style="width:100%"
                                        @change="carregarAuditoria"></el-date-picker>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-date-picker v-model="filtroAud.ate" type="date" placeholder="Até"
                                        value-format="yyyy-MM-dd" style="width:100%"
                                        @change="carregarAuditoria"></el-date-picker>
                    </el-col>
                </el-row>

                <div class="container-table" v-loading="!statusAud">
                    <table class="table table-striped">
                        <thead>
                            <tr><th style="width:150px">Quando</th><th>Usuário</th>
                                <th style="width:130px">Ação</th><th style="width:100px">Tipo</th>
                                <th>Detalhe</th><th style="width:120px" class="hidden-mobile">IP</th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="m in movimentacoes" :key="m.id">
                                <td>{{ m.created_at | formatarData }}</td>
                                <td>{{ m.usuario }}</td>
                                <td><el-tag size="mini" :type="corAcao(m.acao)">{{ m.acao }}</el-tag></td>
                                <td>{{ m.alvo_tipo }}</td>
                                <td class="meta">{{ m.descricao || '—' }}</td>
                                <td class="hidden-mobile meta">{{ m.ip || '—' }}</td>
                            </tr>
                            <tr v-if="!movimentacoes.length && statusAud">
                                <td colspan="6" class="u-text-center">Nenhuma movimentação registrada.</td>
                            </tr>
                        </tbody>
                    </table>

                    <el-row v-if="statusAud">
                        <el-col :xs="24" :sm="12">
                            <div class="u-text-left u-mt-10">
                                Mostrando {{ pagAud.from }} até {{ pagAud.to }} de {{ pagAud.qtdItens }} registros.
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="12" v-if="pagAud.qtdItens > 30">
                            <div class="u-text-right">
                                <el-pagination :current-page="pagAud.page" class="u-mt-10" :total="pagAud.qtdItens"
                                               @current-change="p => { pagAud.page = p; carregarAuditoria() }"
                                               :page-size="30" background layout="prev, pager, next" small></el-pagination>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>

            <!--
              DOC 18 (bloco AF-1) — "conceder e editar as autorizações necessárias para cada um".

              A auditoria 13 derrubou este item porque só existia a troca do PERFIL INTEIRO, na
              tela geral de usuários. Aqui a autorização é por PESSOA e por CAPACIDADE.

              Cada switch tem três estados de propósito: "do perfil" (sem exceção gravada),
              "concedida" e "revogada". Sem o estado neutro não haveria como desfazer uma
              exceção e devolver a pessoa à regra do perfil dela.
            -->
            <el-tab-pane label="Autorizações" name="autorizacoes">
                <el-row :gutter="10" class="u-mt-10 u-mb-10">
                    <el-col :xs="24" :sm="10">
                        <el-input v-model="filtroAut.termo" placeholder="Pesquisar usuário pelo nome"
                                  clearable @keyup.enter.native="carregarAutorizacoes"
                                  @clear="carregarAutorizacoes">
                            <el-button slot="append" icon="el-icon-search"
                                       @click="carregarAutorizacoes"></el-button>
                        </el-input>
                    </el-col>
                    <el-col :xs="24" :sm="14" class="u-text-right hidden-xs-only">
                        <small class="u-text-muted">
                            ler = acessa o módulo · escrever = cria e edita ·
                            criar pasta raiz · gerir = administra esta tela
                        </small>
                    </el-col>
                </el-row>

                <div v-loading="statusAut">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Usuário</th>
                                <th class="hidden-xs-only" style="width:150px">Perfil</th>
                                <th v-for="c in capacidades" :key="c" style="width:150px">
                                    {{ rotuloCapacidade(c) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="u in usuariosAut" :key="u.id">
                                <td>{{ u.name }}</td>
                                <td class="hidden-xs-only">
                                    <el-tag size="mini" type="info">{{ nomeTipo(u.tipo) }}</el-tag>
                                </td>
                                <td v-for="c in capacidades" :key="c">
                                    <el-select :value="estadoDe(u, c)" size="mini" style="width:100%"
                                               @change="v => definirAutorizacao(u, c, v)">
                                        <el-option label="do perfil" value="perfil"></el-option>
                                        <el-option label="concedida" value="sim"></el-option>
                                        <el-option label="revogada"  value="nao"></el-option>
                                    </el-select>
                                    <small :class="u.capacidades[c].efetivo ? 'u-text-success' : 'u-text-muted'">
                                        {{ u.capacidades[c].efetivo ? 'pode' : 'não pode' }}
                                    </small>
                                </td>
                            </tr>
                            <tr v-if="!usuariosAut.length && !statusAut">
                                <td :colspan="capacidades.length + 2" class="u-text-center u-text-muted">
                                    Nenhum usuário encontrado nesta instituição.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <el-pagination background layout="prev, pager, next" class="u-mt-10"
                                   :current-page="pagAut.page" :total="pagAut.qtdItens"
                                   :page-size="20" @current-change="p => { pagAut.page = p; carregarAutorizacoes() }">
                    </el-pagination>
                </div>
            </el-tab-pane>

            <!--
              DOC 43 e 89 (bloco AF-1) — evidência de que a notificação por E-MAIL saiu.

              A auditoria 13 mostrou que a notificação interna vinha sendo contada como e-mail.
              Esta aba existe para que a diferença seja visível e demonstrável: aqui só aparece
              o que passou pelo transporte de e-mail, com o resultado de cada envio.

              O endereço não é exibido — o model o mantém em `$hidden`.
            -->
            <el-tab-pane label="E-mails enviados" name="emails">
                <el-row :gutter="10" class="u-mt-10 u-mb-10">
                    <el-col :xs="12" :sm="5">
                        <el-select v-model="filtroEmail.evento" placeholder="Evento" clearable
                                   style="width:100%" @change="carregarEmails">
                            <el-option v-for="e in eventosEmail" :key="e" :label="e" :value="e"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-select v-model="filtroEmail.situacao" placeholder="Situação" clearable
                                   style="width:100%" @change="carregarEmails">
                            <el-option label="Enviado"  value="enviado"></el-option>
                            <el-option label="Falha"    value="falha"></el-option>
                            <el-option label="Pendente" value="pendente"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <div v-loading="statusEmail">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width:150px">Quando</th>
                                <th>Destinatário</th>
                                <th class="hidden-xs-only">Assunto</th>
                                <th style="width:120px">Evento</th>
                                <th style="width:110px">Situação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="e in emails" :key="e.id">
                                <td>{{ (e.enviado_em || e.created_at) | formatarData }}</td>
                                <td>{{ e.destinatario_usuario ? e.destinatario_usuario.name : 'externo' }}</td>
                                <td class="hidden-xs-only">{{ e.assunto }}</td>
                                <td><el-tag size="mini" type="info">{{ e.evento }}</el-tag></td>
                                <td>
                                    <el-tag size="mini"
                                            :type="e.situacao === 'enviado' ? 'success' : (e.situacao === 'falha' ? 'danger' : 'warning')">
                                        {{ e.situacao }}
                                    </el-tag>
                                </td>
                            </tr>
                            <tr v-if="!emails.length && !statusEmail">
                                <td colspan="5" class="u-text-center u-text-muted">
                                    Nenhum e-mail enviado ainda.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>

        <!-- campo adicional -->
        <el-dialog :title="campoForm.id ? 'Editar campo' : 'Novo campo adicional'"
                   :visible.sync="dialogCampo" width="520px">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Nome"><el-input v-model="campoForm.nome" maxlength="120"></el-input></el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Tipo">
                            <el-select v-model="campoForm.tipo" style="width:100%">
                                <el-option v-for="t in tiposCampo" :key="t" :label="t" :value="t"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item v-if="campoForm.tipo === 'lista'" label="Opções (uma por linha)">
                    <el-input v-model="campoForm.opcoesTexto" type="textarea" :rows="4"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="campoForm.obrigatorio">Obrigatório</el-checkbox>
                    <el-checkbox v-model="campoForm.ativo">Ativo</el-checkbox>
                    <el-checkbox v-if="!campoForm.id" v-model="campoForm.da_rede">Campo da rede</el-checkbox>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogCampo = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarCampo">SALVAR</el-button>
            </span>
        </el-dialog>

        <!-- regra -->
        <el-dialog :title="regraForm.id ? 'Editar regra' : 'Nova regra de armazenamento'"
                   :visible.sync="dialogRegra" width="620px">
            <el-form label-position="top">
                <el-form-item label="Nome da regra">
                    <el-input v-model="regraForm.nome" maxlength="120"></el-input>
                </el-form-item>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Quando o campo">
                            <el-select v-model="regraForm.campo_id" clearable placeholder="Qualquer documento"
                                       style="width:100%">
                                <el-option v-for="c in campos" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="For igual a">
                            <el-input v-model="regraForm.valor_gatilho" maxlength="180"
                                      placeholder="Qualquer valor"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Guardar na pasta (DOC 56)">
                    <el-select v-model="regraForm.pasta_destino_id" clearable placeholder="Nenhuma"
                               style="width:100%">
                        <el-option v-for="p in pastas" :key="p.id" :label="p.caminho" :value="p.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Ou montar o caminho com variáveis (DOC 57)">
                    <el-input v-model="regraForm.caminho_modelo" maxlength="500"
                              placeholder="/RH/{ano}/{mes}"></el-input>
                </el-form-item>
                <el-form-item label="Renomear o documento (DOC 58)">
                    <el-input v-model="regraForm.nome_modelo" maxlength="255"
                              placeholder="{ano}-{mes}-{titulo}"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="regraForm.ativo">Ativa</el-checkbox>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogRegra = false">Cancelar</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarRegra">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '—' }
    },
    data: () => ({
        aba: 'campos',
        tiposCampo: ['texto', 'numero', 'data', 'lista', 'booleano'],
        acoes: ['criou','editou','moveu','excluiu','restaurou','baixou','versionou',
                'compartilhou','descompartilhou','transferiu','publicou','despublicou'],

        statusCampos: false, campos: [],
        dialogCampo: false,
        campoForm: { id: null, nome: '', tipo: 'texto', opcoesTexto: '', obrigatorio: false, ativo: true, da_rede: false },

        statusRegras: false, regras: [], pastas: [], variaveis: [],
        dialogRegra: false,
        regraForm: { id: null, nome: '', campo_id: '', valor_gatilho: '', pasta_destino_id: '',
                     caminho_modelo: '', nome_modelo: '', ativo: true },

        statusTransf: false, transferencias: [], usuarios: [], buscando: false, previa: null,
        transf: { de_user_id: '', para_user_id: '' },

        statusAud: false, movimentacoes: [],
        filtroAud: { acao: '', alvo_tipo: '', de: '', ate: '' },
        pagAud: { page: 1, qtdItens: 0, from: '', to: '' },

        // DOC 18 — autorizações por usuário
        statusAut: false, usuariosAut: [], capacidades: [],
        filtroAut: { termo: '' },
        pagAut: { page: 1, qtdItens: 0 },

        // DOC 43, 89 — evidência de e-mail
        statusEmail: false, emails: [],
        eventosEmail: ['solicitacao', 'lembrete', 'concluido', 'recusado', 'cancelado'],
        filtroEmail: { evento: '', situacao: '' }
    }),
    computed: {
        variaveisTexto () { return this.variaveis.map(v => v.variavel).join(' ') }
    },
    mounted () {
        this.carregarCampos()
        this.carregarRegras()
        this.carregarPastas()
        this.carregarVariaveis()
        this.carregarTransferencias()
        this.carregarAuditoria()
        this.carregarAutorizacoes()
        this.carregarEmails()
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        // ------------------------------------------------ DOC 18: autorizações
        rotuloCapacidade (c) {
            const m = { ler: 'Ler', escrever: 'Escrever',
                        criar_pasta_raiz: 'Criar pasta raiz', gerir: 'Gerir' }
            return m[c] || c
        },
        nomeTipo (t) {
            return (this.$CONSTANTS && this.$CONSTANTS.TIPO_USER && this.$CONSTANTS.TIPO_USER[t]) || ('tipo ' + t)
        },
        /* Três estados: sem exceção gravada a pessoa segue o perfil dela. */
        estadoDe (u, c) {
            const e = u.capacidades[c].excecao
            if (e === null || e === undefined) return 'perfil'
            return e ? 'sim' : 'nao'
        },
        carregarAutorizacoes () {
            this.statusAut = true
            this.$axios.post(`${this.base()}/api/documento-gestao/autorizacao/listar`, {
                termo: this.filtroAut.termo, page: this.pagAut.page
            }, this.auth()).then(r => {
                this.usuariosAut = r.data.data || []
                this.capacidades = r.data.capacidades || []
                this.pagAut.qtdItens = r.data.total || 0
                this.statusAut = false
            }).catch(e => {
                this.statusAut = false
                this.usuariosAut = []
                // 403 aqui é esperado para quem não gere: a aba fica vazia, sem alarme.
                if (e.response && e.response.status !== 403) {
                    this.$message.error((e.response.data && e.response.data.message) || 'Falha ao carregar autorizações.')
                }
            })
        },
        definirAutorizacao (u, capacidade, valor) {
            const permitido = valor === 'perfil' ? null : (valor === 'sim')

            this.$axios.post(`${this.base()}/api/documento-gestao/autorizacao/definir`, {
                user_id: u.id, capacidade, permitido
            }, this.auth()).then(() => {
                this.$message.success('Autorização atualizada.')
                this.carregarAutorizacoes()
            }).catch(e => {
                this.$message.error((e.response && e.response.data && e.response.data.message)
                    || 'Não foi possível alterar a autorização.')
                this.carregarAutorizacoes()
            })
        },

        // ------------------------------------------------ DOC 43, 89: e-mails
        carregarEmails () {
            this.statusEmail = true
            this.$axios.post(`${this.base()}/api/documento-gestao/email/listar`, {
                evento: this.filtroEmail.evento, situacao: this.filtroEmail.situacao
            }, this.auth()).then(r => {
                this.emails = (r.data && r.data.data) || []
                this.statusEmail = false
            }).catch(() => { this.statusEmail = false; this.emails = [] })
        },

        instituicaoAtual () {
            const i = this.$store.state.config.instituicao
            return i ? i.id : null
        },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        corAcao (a) {
            if (a === 'excluiu') return 'danger'
            if (a === 'criou' || a === 'restaurou') return 'success'
            if (a === 'compartilhou' || a === 'publicou') return 'warning'
            return 'info'
        },

        nomePasta (id) {
            const p = this.pastas.find(x => Number(x.id) === Number(id))
            return p ? p.caminho : null
        },

        descricaoGatilho (r) {
            if (!r.campo_id) return 'Qualquer documento'
            const c = this.campos.find(x => Number(x.id) === Number(r.campo_id))
            const nome = c ? c.nome : 'campo ' + r.campo_id
            return r.valor_gatilho ? `${nome} = ${r.valor_gatilho}` : `${nome} preenchido`
        },

        // ------------------------------------------------ campos
        carregarCampos () {
            this.statusCampos = false
            this.$axios.post(`${this.base()}/api/documento-gestao/campo/getAllPaginate`, {}, this.auth())
                .then(r => { this.campos = r.data.data; this.statusCampos = true })
                .catch(e => { this.statusCampos = true; this.erro(e) })
        },

        abrirCampo (c) {
            if (c) {
                let op = ''
                try { op = c.opcoes ? JSON.parse(c.opcoes).join('\n') : '' } catch (e) { op = c.opcoes || '' }
                this.campoForm = { id: c.id, nome: c.nome, tipo: c.tipo, opcoesTexto: op,
                                   obrigatorio: !!c.obrigatorio, ativo: !!c.ativo, da_rede: false }
            } else {
                this.campoForm = { id: null, nome: '', tipo: 'texto', opcoesTexto: '',
                                   obrigatorio: false, ativo: true, da_rede: false }
            }
            this.dialogCampo = true
        },

        salvarCampo () {
            const payload = {
                nome: this.campoForm.nome, tipo: this.campoForm.tipo,
                obrigatorio: this.campoForm.obrigatorio, ativo: this.campoForm.ativo
            }

            if (this.campoForm.tipo === 'lista') {
                payload.opcoes = this.campoForm.opcoesTexto.split('\n').map(s => s.trim()).filter(Boolean)
            }

            if (!this.campoForm.id) {
                if (this.campoForm.da_rede) payload.da_rede = true
                else payload.instituicao_id = this.instituicaoAtual()
            }

            const url = this.campoForm.id
                ? `${this.base()}/api/documento-gestao/campo/update/${this.campoForm.id}`
                : `${this.base()}/api/documento-gestao/campo/store`

            window.eventBus.$emit('loading', true)
            this.$axios.post(url, payload, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                this.dialogCampo = false
                this.carregarCampos()
            }).catch(e => { this.erro(e) })
        },

        excluirCampo (c) {
            this.$msgbox.confirm('Excluir este campo?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/documento-gestao/campo/delete/${c.id}`, this.auth())
                    .then(r => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', {
                            msg: r.data.inativado ? r.data.mensagem : 'Sucesso! - Campo excluído.', type: 'success'
                        })
                        this.carregarCampos()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        // ------------------------------------------------ regras
        carregarRegras () {
            this.statusRegras = false
            this.$axios.post(`${this.base()}/api/documento-gestao/regra/getAllPaginate`, {}, this.auth())
                .then(r => { this.regras = r.data.data; this.statusRegras = true })
                .catch(e => { this.statusRegras = true; this.erro(e) })
        },

        carregarPastas () {
            this.$axios.post(`${this.base()}/api/documento-pasta/arvore`, {}, this.auth())
                .then(r => { this.pastas = this.achatar(r.data) })
                .catch(() => {})
        },

        achatar (nos, acc) {
            acc = acc || []
            nos.forEach(n => { acc.push(n); if (n.filhas && n.filhas.length) this.achatar(n.filhas, acc) })
            return acc
        },

        carregarVariaveis () {
            this.$axios.get(`${this.base()}/api/documento-gestao/regra/variaveis`, this.auth())
                .then(r => { this.variaveis = r.data })
                .catch(() => {})
        },

        abrirRegra (r) {
            this.regraForm = r
                ? { id: r.id, nome: r.nome, campo_id: r.campo_id || '', valor_gatilho: r.valor_gatilho || '',
                    pasta_destino_id: r.pasta_destino_id || '', caminho_modelo: r.caminho_modelo || '',
                    nome_modelo: r.nome_modelo || '', ativo: !!r.ativo }
                : { id: null, nome: '', campo_id: '', valor_gatilho: '', pasta_destino_id: '',
                    caminho_modelo: '', nome_modelo: '', ativo: true }
            this.dialogRegra = true
        },

        salvarRegra () {
            const payload = Object.assign({}, this.regraForm)
            delete payload.id
            if (!this.regraForm.id) payload.instituicao_id = this.instituicaoAtual()

            const url = this.regraForm.id
                ? `${this.base()}/api/documento-gestao/regra/update/${this.regraForm.id}`
                : `${this.base()}/api/documento-gestao/regra/store`

            window.eventBus.$emit('loading', true)
            this.$axios.post(url, payload, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                this.dialogRegra = false
                this.carregarRegras()
            }).catch(e => { this.erro(e) })
        },

        excluirRegra (r) {
            this.$msgbox.confirm('Excluir esta regra?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/documento-gestao/regra/delete/${r.id}`, this.auth())
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Regra excluída.', type: 'success' })
                        this.carregarRegras()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        // ------------------------------------------------ transferência
        buscarUsuarios (termo) {
            if (!termo || termo.length < 2) return
            this.buscando = true
            this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/usuarios`,
                { termo: termo, instituicao_id: this.instituicaoAtual() }, this.auth()).then(r => {
                this.usuarios = r.data
                this.buscando = false
            }).catch(e => { this.buscando = false; this.erro(e) })
        },

        carregarPrevia () {
            if (!this.transf.de_user_id) { this.previa = null; return }
            this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/previa`,
                { de_user_id: this.transf.de_user_id, instituicao_id: this.instituicaoAtual() },
                this.auth()).then(r => { this.previa = r.data }).catch(e => { this.erro(e) })
        },

        executarTransferencia () {
            this.$msgbox.confirm(
                'Todos os documentos e pastas do usuário de origem passarão para o de destino. Continuar?',
                'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/executar`,
                    Object.assign({ instituicao_id: this.instituicaoAtual() }, this.transf), this.auth()
                ).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Acervo transferido.', type: 'success' })
                    this.transf = { de_user_id: '', para_user_id: '' }
                    this.previa = null
                    this.carregarTransferencias()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        carregarTransferencias () {
            this.statusTransf = false
            this.$axios.post(`${this.base()}/api/documento-gestao/transferencia/listar`, {}, this.auth())
                .then(r => { this.transferencias = r.data.data; this.statusTransf = true })
                .catch(() => { this.statusTransf = true })
        },

        // ------------------------------------------------ auditoria
        carregarAuditoria () {
            this.statusAud = false
            this.$axios.post(`${this.base()}/api/documento-gestao/auditoria/listar?page=${this.pagAud.page}`,
                this.filtroAud, this.auth()).then(r => {
                this.movimentacoes = r.data.data
                this.pagAud.qtdItens = r.data.total
                this.pagAud.from = r.data.from
                this.pagAud.to = r.data.to
                this.statusAud = true
            }).catch(() => { this.statusAud = true })
        }
    }
}
</script>
<style scoped>
.meta { font-size: 12px; color: #909399; }
.u-ml-5 { margin-left: 5px; }
</style>
